














































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import {
  fontFaceList,
  fontSizeOptions
} from '../../../constant/options';
import {
  getIconImageList
} from "@/services/api";
import { getCompanyInfo } from "@/model/CompanyInfo";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";
import FontPicker from "@/components/FontPicker/index.vue";
import { BIG_WHEEL_TPLID, isIconBeforeShowConfig } from "@/utils/experiment";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    "font-picker": FontPicker,
  },
})
export default class wheelOfFortuneTextPackUp extends Vue {
  @Prop(String)
  activePageSetting!: string;

  @Prop(Object)
  formData!: PopSettingsVO;

  @Prop(Number)
  triggerEventType!: number;

  imageDialogVisible = false;
  selectImageUrl: string = '';
  imageList: { id: number, imageName: string, imageUrl: string }[] = [];

  formDataStart: any = this.formData

  imgNameArr = [
    { imgName: 'left_top_', top: '20px', left: '20px' },
    { imgName: 'right_top_', top: '20px', right: '20px' },
    { imgName: 'left_center_', top: '47%', left: '20px' },
    { imgName: 'right_center_', top: '47%', right: '20px' },
    { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
    { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
  ]
  imgNameObjArr = [
    "LeftTop", "RightTop", "LeftMiddle", "RightMiddle", "LeftBottom", "RightBottom"
  ]
  get iconSizeOption() {
    return [
      { label: this.$t('views.wheeloffortune.setting.text_5c0f') as string, value: 'Small' },
      { label: this.$t('views.wheeloffortune.setting.text_4e2d') as string, value: 'Medium' },
      { label: this.$t('views.wheeloffortune.setting.text_5927') as string, value: 'Big' },
    ]
  }

  get countDownUnitOptions() {
    return [
      { name: this.$t('views.wheeloffortune.list.text_5206949f') as string, value: 'min' },
      { name: this.$t('views.wheeloffortune.list.text_79d2') as string, value: 'sec' },
    ]
  }

  selectImgVis = 1

  bannerImgNameArr = ['banner_top_', 'banner_bottom_']

  selectBannerImgVis = 1

  uploadUrl = getVueAppUploadApi() + "/upload/formImage";

  uploadShow = false;

  uploadFileList: { name: string, url: string }[] = [];

  uploadDialogVisible = false;

  uploadDialogUrl = '';

  get token() {
    return localStorage.getItem("token") || "default";
  }

  get companyIs450() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return companyId === 450 || companyId === 30 || companyId === 313 || companyId === 721 || companyId === 583 || companyId === 608;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535
    return status;
  }

  get enableFormOptimize() {
    return true;
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1;
  }

  get enableIconBeforeShowConfig() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return isIconBeforeShowConfig() && ![...BIG_WHEEL_TPLID].includes(tid) && this.triggerEventType === 0;
  }

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]

  fontFaceList = getFontFaceList(fontFaceList);
  fontSizeOptions = fontSizeOptions;

  activeNames = 1
  handleChange(){}

  handleSelectIcon() {
    // console.log(this.selectImageUrl);
    if (this.selectImageUrl) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = this.selectImageUrl);
      this.uploadFileList = [{
        name: '',
        url: this.selectImageUrl
      }];
    }
    this.imageDialogVisible = false;
    // console.log('handleSelectIcon');
  }

  openFloatBanner() {
    if(!this.formDataStart.settings.rules.couponCodeShow || !this.formData.settings.rules.couponCodePosition){
      this.formDataStart.settings.banner.floatBannerShow = false
      this.$message({
        message: this.$t('views.wheeloffortune.pop.text_97005f00542f5c55') as string,
        type: 'warning'
      });
    } else {
      this.$forceUpdate();
      this.$emit('change',this.formDataStart)
    }
    window?.gtagClick('form_tool_collapseFloatBar','弹窗_编辑订阅工具_收起_修改code浮条')
  }
  openBanner(){
    if(!this.formDataStart.settings.rules.couponCodeShow || !this.formData.settings.rules.couponCodePosition){
      this.formDataStart.settings.banner.bannerShow = false
      this.$message({
        message: this.$t('views.wheeloffortune.pop.text_97005f00542f5c55') as string,
        type: 'warning'
      });
    }
    window?.gtagClick('form_tool_collapseBanner','弹窗_编辑订阅工具_收起_修改横幅')
  }

  countDownChange() {
    if (this.formDataStart.settings.banner.countDownNum < 1) {
      this.formDataStart.settings.banner.countDownNum = 1;
    } else if (this.formDataStart.settings.banner.countDownNum > 60) {
      this.formDataStart.settings.banner.countDownNum = 60;
    }
    this.changeStart();
  }

  created() {
    if (this.formDataStart.settings.position.iconSizeType) {
      switch (this.formDataStart.settings.position.iconSizeType) {
        case 'Small':
          this.formDataStart.settings.position.iconWidth = 30;
          break;
        case 'Medium':
          this.formDataStart.settings.position.iconWidth = 50;
          break;
        case 'Big':
          this.formDataStart.settings.position.iconWidth = 80;
          break;
        default:
          this.formDataStart.settings.position.iconWidth = 50;
          break;
      }
    }

    // https://u60z777w08.feishu.cn/docx/BfE5dvNA9omAQPx5j7vcxlMtnTc 需求，默认为true
    if (this.formDataStart?.settings?.rules?.couponCodeShow === true && !!this.formDataStart.settings.rules.couponCodePosition && this.formDataStart?.settings?.banner?.floatBannerShow === undefined) {
      if (this.triggerEventType === 1 || this.triggerEventType === 2 || this.triggerEventType === 3 || this.triggerEventType === 5 || this.triggerEventType === 6) {
        // 浮条的开启，前置条件coupon展示必须也要开启；浮条可以单独开启关闭；coupon展示关闭，浮条则关闭
        this.formDataStart.settings.banner.floatBannerShow = true;
      }
    }

    this.formDataStart.settings.position.iconSizeType = this.formDataStart.settings.position.iconSizeType ?? 'Medium'
    this.formDataStart.settings.position.iconShow = Boolean(this.formDataStart.settings.position.iconShow)  ?? true
    this.formDataStart.settings.position.iconTiming = this.formDataStart.settings.position.iconTiming ?? 'after'
    
    if (this.formData.settings.position.iconUrl) {
      this.uploadShow = true
      this.uploadFileList = [
        {
          name: '',
          url: this.formData.settings.position.iconUrl,
        }
      ]
    }
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) + 1

    if(this.formDataStart.settings.banner.position == 'top'){
      this.selectBannerImgVis = 1
    }else{
      this.selectBannerImgVis = 2
    }

    // 确保iconExcludePages是数组
    if (!this.formDataStart.settings.targeting.iconExcludePages) {
      this.$set(this.formDataStart.settings.targeting, 'iconExcludePages', []);
    }

    // 请求icon列表
    getIconImageList({}).then((res: any) => {
      this.imageList = res.data.data;
    });

    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }


  /**
   * 图片上传失败钩子函数
   */
  handleError(e: any): void {
    this.uploadShow = false;
    this.$message.warning(this.$t('views.wheeloffortune.setting.text_56fe72474e0a4f20') as string);
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert(this.$t('views.usergroupingupload.text_767b5f5559316548') as string);
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(this.$router.currentRoute.fullPath)
    }
    this.changeStart()
  }

  changeIconCustom() {
    if (this.formDataStart.settings.position.iconCustom) {
      const isMiddle = ['LeftMiddle', 'RightMiddle'].includes(this.formDataStart.settings.position.position);
      const isTop = ['LeftTop', 'RightTop'].includes(this.formDataStart.settings.position.position);
      if (!isTop) {
        this.formDataStart.settings.position.iconCustomBottom = isMiddle ? 50 : 100;
      }
      this.formDataStart.settings.position.iconCustomBottomUnit = isMiddle ? '%' : 'px';
    } else {
      this.formDataStart.settings.position.iconCustomBottom = undefined;
      this.formDataStart.settings.position.iconCustomBottomUnit = undefined;
    }
    this.reportIconCustomClick();
    this.changeStart()
  }

  // icon 可关闭
  changeIconClose(val: boolean) {
    this.formDataStart.settings.position.iconClose = val;
    this.changeStart();
  }

  reportIconCustomClick() {
    window?.gtagClick('form_edit_setIcon_spacing','弹窗_编辑订阅工具_设置icon_间距设置');
  }

  /**
   * icon图片切换
   */
  selectImgClick(index: number) {
    this.formDataStart?.settings?.position && (
      this.formDataStart.settings.position.position = ['LeftTop', 'RightTop', 'LeftMiddle', 'RightMiddle', 'LeftBottom', 'RightBottom'][index]
    );
    this.selectImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }

  /**
   * banner图片切换
   */
  selectBannerImgClick(index: number){
    this.formDataStart.settings.banner.position = ['top', 'bottom'][index]
    this.selectBannerImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }

  /**
   * 图片上传成功钩子函数
   */
  handleSuccess(
    res: { data: { url: string, message:string }[] },
    file: any,
    fileList: any
  ): void {
    this.uploadShow = true;

    if(res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = res.data[0].url);
      this.uploadFileList = res.data[0].url ? [{name: '', url: res.data[0].url}]: []
      this.$forceUpdate()
    } else {
      fileList.splice(0, fileList.length);
      this.uploadShow = false;
      this.$message.warning(res.data[0].message);
    }

    this.changeStart()

  }

  /**
   * 图片上传前钩子函数
   */
  beforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/webp" ||
      file.type === "image/png";
    if (!isIMAGE) {
      this.$message.error(this.$t('views.wheeloffortune.setting.text_4e0a4f2065874ef6') as string);
      return false;
    }
    if (file.size / 1024 / 1024 > 5) {
      this.$message.error(this.$t('views.wheeloffortune.pop.stylesetting.textpackup.max-5m') as string);
      return false;
    }
    this.uploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  uploadUrlDelete() {
    this.uploadShow = false;
    this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = '');
  }
  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }


  changeStart() {
    switch (this.formDataStart.settings.position.iconSizeType) {
      case 'Small':
        this.formDataStart.settings.position.iconWidth = 30;
        break;
      case 'Medium':
        this.formDataStart.settings.position.iconWidth = 50;
        break;
      case 'Big':
        this.formDataStart.settings.position.iconWidth = 80;
        break;
      default:
        this.formDataStart.settings.position.iconWidth = 50;
        break;
    }
    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }
  @Watch('formData.settings.position.position')
  positionChange(){
    // console.log(this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1)
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1
  }

  validateNumberInput() {
    try {
      const newVal = parseInt(this.formDataStart.settings.position.iconCustomBottom.toString().replace(/[^\d]/g, ''), 10)
      // 兼容element input 数字0校验异常
      this.formDataStart.settings.position.iconCustomBottom = newVal === 0 ? '0' : newVal;
    } catch (error) {
      console.log('validateNumberInput error', error);
    }
    this.changeStart();
  }

}
